import { FC } from 'react';
import { ApptRequestsView } from '../views/appt-requests/appt-requests';
import { CancellationRequestViewWithProvider } from '../views/cancellation-request/cancellation-request-with-provider';
import { FiltersView } from '../views/filters/filters';
import { RequestDetailsViewWithProvider } from '../views/request-details/request-details-with-provider';
import { RescheduleRequestViewWithProvider } from '../views/reschedule-request/reschedule-request-with-provider';

export enum ApptRequestsWidgetRoutePath {
    APPT_REQUESTS = '/',
    FILTERS = '/filters',
    REQUEST_DETAILS = '/request-details',
    RESCHEDULE_REQUEST = '/reschedule-request',
    CANCELLATION_REQUEST = '/cancellation-request'
}

export interface ApptRequestsWidgetRoute {
    path: ApptRequestsWidgetRoutePath;
    props?: any;
}

export type RouteConfigItem = { path: ApptRequestsWidgetRoutePath; name: string; component: FC<any> };

export const RouteConfig: RouteConfigItem[] = [
    { path: ApptRequestsWidgetRoutePath.APPT_REQUESTS, component: ApptRequestsView, name: '' },
    { path: ApptRequestsWidgetRoutePath.FILTERS, component: FiltersView, name: '' },
    { path: ApptRequestsWidgetRoutePath.REQUEST_DETAILS, component: RequestDetailsViewWithProvider, name: '' },
    { path: ApptRequestsWidgetRoutePath.RESCHEDULE_REQUEST, component: RescheduleRequestViewWithProvider, name: '' },
    { path: ApptRequestsWidgetRoutePath.CANCELLATION_REQUEST, component: CancellationRequestViewWithProvider, name: '' },
];
